import React from "react";
import "./messages.css";

const NotificationModal = ({ show, onClose, notifications, onMarkAll }) => {
  if (!show) return null;

  const formatTime = (time) => {
    if (!time) return "";
    const diff = Math.floor((new Date() - new Date(time)) / (1000 * 60 * 60));
    if (diff < 1) return "Just now";
    if (diff < 24) return diff + "h";
    return Math.floor(diff / 24) + "d";
  };

  return (
    <div className="notif-container-attached">
      <div className="notif-modal">
        <div className="notif-header">
          <h5>Notifications</h5>
          <button className="notif-close" onClick={onClose}>✕</button>
        </div>

      <div className="notif-body">
  {notifications && notifications.length > 0 ? (
    notifications.map((item, idx) => (
      <div
        key={idx}
        className={`notif-item ${item.is_read === 0 ? "notif-unread" : ""}`}
      >
        <div className="notif-content">
          <p dangerouslySetInnerHTML={{ __html: item.message }} />
        </div>

        <div className="notif-time">{formatTime(item.created_at)}</div>
      </div>
    ))
  ) : (
    <p className="text-center p-2">No notifications</p>
  )}
</div>


        <div className="notif-footer">
          <button className="notif-markall" onClick={onMarkAll}>
            Mark all as viewed
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
